import React from "react";

const tabs = ["Šifarnici", "Mjerna mjesta", "Očitanja", "Učitavanje"];

function CodebookTabs({ activeTab, onClick }) {
    return (
        <div className="tab-container">
            {tabs.map(tab => (
                <button
                    key={tab}
                    className={`tab-button ${activeTab === tab ? "active" : ""}`}
                    onClick={() => onClick(tab)}
                >
                    {tab === "Učitavanje" ? "Učitavanje fajlova" : tab}
                </button>
            ))}
        </div>
    );
}

export default CodebookTabs;
